var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagPending"},[_c('translate',[_vm._v("Pending")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }